import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class PolicyManageService {
    daysAccruedPerPeriodChangedSubject$ = new Subject<boolean>();
}
